<template>
    <div class="modal-container modal-child">
        <div class="modal-header">
            <h4 class="modal-title">Duplicate Details</h4>
        </div>
        <div class="modal-body">
            <div class="md-layout-item">
                <md-datepicker
                    class="date-clone-filter"
                    ref="mdDatePicker"
                    v-model="tripDate"
                    md-immediately
                    :md-debounce="10"
                >
                    <label>Trip Date</label>
                </md-datepicker>
            </div>

            <md-field class="driver-clone-filter">
                <div class="driver-icon md-just-icon md-round">
                    <md-icon>account_circle</md-icon>
                </div>
                <div class="driver-clone-filter">
                    <vue-select
                        class="driver-filter"
                        :reduce="(fullName) => fullName.userId"
                        label="fullName"
                        :options="filteredTeamMemberList"
                        placeholder="Team Member"
                        v-model.number="teamMemberFilterValue"
                        :searchable="$root.isDesktop"
                    ></vue-select>
                </div>
            </md-field>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-default confirm-button" @click.stop="$modal.hide">Cancel</md-button>
            <md-button class="dialog-button md-primary confirm-button" @click.stop="confirm">Confirm</md-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { GeneralMixin } from '@/mixins';

export default {
    name: 'CloneJobEditModal',
    mixins: [GeneralMixin],
    computed: {
        ...mapGetters({
            user: 'user/user',
            allTeamMembers: 'team/teamMembers'
        })
    },
    async mounted() {
        if (this.stopDetails && this.stopDetails.tripDate) 
            this.tripDate = moment(this.stopDetails.tripDate).toDate();

        if (this.shipmentDetails && this.shipmentDetails.tripDate)
            this.tripDate = moment(this.shipmentDetails.tripDate).toDate();

        this.selectedTeamRegionId = this.user.teamRegionId;
        this.filteredTeamMemberList = this.allTeamMembers;

        if (this.user.teamRegionId)
            this.filteredTeamMemberList = this.allTeamMembers.filter(
                (x) => x.teamRegionId === this.user.teamRegionId || x.parentTeamRegionId === this.user.teamRegionId
            );
    },
    data() {
        return {
            tripDate: null,
            selectedTeamRegionId: null,
            updateClonedDetails: null,
            userId: null,
            teamMemberFilterValue: null,
            filteredTeamMemberList: []
        };
    },
    props: {
        stopDetails: {
            type: Object,
            default: () => {}
        },
        shipmentDetails: {
            type: Object,
            default: () => {}
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        confirm() {
            let dateTime;
            if (this.tripDate) 
                dateTime = moment(this.tripDate).format('YYYY-MM-DD');

            this.updateClonedDetails = {
                tripDate: dateTime ?? null,
                userId: this.teamMemberFilterValue ?? null
            };

            const data = this.updateClonedDetails;
            this.resolve({ result: 'confirm', data });
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-child {
    width: 400px !important;
    justify-self: center;
}

.confirm-button {
    float: right;
}

.date-clone-filter {
    width: 310px !important;
}

.driver-clone-filter {
    margin-left: 15px;
    width: 300px !important;
}

.driver-filter {
    margin-left: 10px;
}

.driver-icon {
    position: fixed;
}
</style>
